import styled, { css } from 'styled-components';

export const BaseFont = styled.h1`
  && {
    ${({ weight }) => (weight
    ? css`
            font-weight: ${weight} !important;
          `
    : '')}
  }
`;
